import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { IIndicator } from "@gtmhub/error-handling";
import { Insight, InsightSelectorData } from "@webapp/data-story/models/insights.models";

@Component({
  selector: "selected-automation",
  templateUrl: "./selected-automation.component.html",
  styleUrls: ["./selected-automation.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedAutomationComponent {
  @Input() public data: InsightSelectorData;
  @Input() public confirmedInsight: Insight;
  @Input() public readonly: boolean;
  @Input() public isEditable: boolean;
  @Input() public indicators: { loading?: IIndicator; loadingParams?: IIndicator };

  @Output() public readonly editFilter = new EventEmitter<void>();
  @Output() public readonly removeItem = new EventEmitter<void>();
  @Output() public readonly goToInsight = new EventEmitter<void>();
  @Output() public readonly openInsight = new EventEmitter<void>();
}
